import styled from "styled-components";
import { Loader } from "@styled-icons/feather";

export const Loading = styled(Loader).attrs({
  size: 24,
  className: "icon-spin",
})``;
